import { useConfig } from "~/constants";

type TallyOptionType = {
  length: number;
  quantity: number;
  is_wish: boolean;
};

type TallyOptionsResponseType = {
  product_sku: string;
  branch_id: number;
  tally: TallyOptionType[];
};

const useTally = () => {
  const { baseUrl, headers } = useConfig();

  const tallyOptions = ref<TallyOptionsResponseType | null>(null);

  const fetchTallyOptions = async (sku: any, branch = null) => {
    if (!branch) return;

    const params = {
      sku,
    };

    const { data, error } = await useAsyncData("getTally", () =>
      $fetch<TallyOptionsResponseType | null>(`${baseUrl}/getTally`, {
        headers,
        body: JSON.stringify(params),
        method: "POST",
        credentials: "include",
      }),
    );

    if (error.value) {
      tallyOptions.value = null;

      return;
    }

    tallyOptions.value = data.value;
  };

  return {
    fetchTallyOptions,
    tallyOptions,
  };
};

export default useTally;
